import cn from 'classnames';
import React from 'react';
import { isVisibleError } from '../../utils/isRealError';
import styles from './ErrorHint.module.css';

interface ErrorHintProps {
  children: React.ReactNode;
  className?: string;
}

/** Если ошибка с невидимым текстом - то не рендерит ничего */
export const ErrorHint: React.FC<ErrorHintProps> = ({ children, className }) => {
  if (!isVisibleError(children)) return null;
  return (
    <div className={cn(styles.errorHint, className)}>
      <span className={styles.symbol}>*</span>
      {children}
    </div>
  );
};
